import React from 'react';

import { withNamespaces, Trans } from 'react-i18next';
import { observer } from 'mobx-react';

import { analytics } from 'core/analytics';

import { clientStore } from 'apps/client/app';

import {
  MessageWrapper,
  LinkStyled,
  ParagraphStyled,
  ButtonStyled,
} from './policyMessage.styled';

@withNamespaces()
@observer
class PolicyMessage extends React.Component {
  render() {
    const { enabled } = analytics;
    if (enabled) return null;
    const { signedInProfile } = clientStore;
    const username = signedInProfile && signedInProfile.username;
    const isCn = window.location.hostname.split('.').pop() === 'cn';
    return (
      <MessageWrapper isCn={isCn} data-test-id='policyMessage'>
        <ParagraphStyled size='small'>
          <Trans>
            To give you the best experience of Wikifactory, we use cookies and
            similar technologies for performance, analytics, personalisation,
            and advertising. By clicking <strong>accept</strong>
            or continuing to browse this site, you are accepting their use and
            agreeing to Wikifactory&apos;s{' '}
            <LinkStyled name='home.privacy'>privacy</LinkStyled> and{' '}
            <LinkStyled name='home.cookies'>cookies</LinkStyled> policies.
          </Trans>
        </ParagraphStyled>
        <ButtonStyled
          data-test-id='policy-message-accept-button'
          text={<Trans>Accept</Trans>}
          size='small'
          onClick={() => {
            analytics.Enable(username);
          }}
        />
      </MessageWrapper>
    );
  }
}

export default PolicyMessage;
